import React from 'react';
import { useSelector } from 'react-redux';
import { richText } from '../../util/richText';
import { LISTING_STATE_DRAFT, LISTING_STATE_PENDING_APPROVAL } from '../../util/types';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  createSlug,
} from '../../util/urlHelpers';
import { NamedLink } from '../../components';
import { getEffectiveLocale } from '../../util/genericHelpers';

import css from './ListingLink.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 16;

const getLocalizedTitle = (listing, lang) => {
  const attrsTitle = listing?.attributes?.title || '';
  if (lang !== 'th') return attrsTitle;

  const thTitle = listing?.attributes?.publicData?.thLanguage?.th?.title;
  return thTitle || attrsTitle;
};

const ListingLink = props => {
  const { className, listing, children } = props;

  const listingLoaded = listing && listing.id;
  if (!listingLoaded) return null;

  const { currentUser } = useSelector(state => state.user);
  const selectedLanguage = getEffectiveLocale(currentUser);

  const id = listing.id.uuid;
  const { state } = listing.attributes;

  // Localized title for display; canonical routes use the source listing title.
  const titleToShow = getLocalizedTitle(listing, selectedLanguage);
  const slug = createSlug(listing.attributes.title || '');

  const richTitle = (
    <span>
      {richText(titleToShow, {
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
        longWordClass: css.longWord,
      })}
    </span>
  );

  const isPendingApproval = state === LISTING_STATE_PENDING_APPROVAL;
  const isDraft = state === LISTING_STATE_DRAFT;

  const variant = isPendingApproval
    ? LISTING_PAGE_PENDING_APPROVAL_VARIANT
    : isDraft
    ? LISTING_PAGE_DRAFT_VARIANT
    : null;

  const linkProps = variant
    ? {
        name: 'ListingPageVariant',
        params: { id, slug, variant },
      }
    : {
        name: 'ListingPage',
        params: { id, slug },
      };

  return (
    <NamedLink className={className} {...linkProps}>
      {children ? children : richTitle || ''}
    </NamedLink>
  );
};

export default ListingLink;
